<template>
    <div style="minHeight:100px;">
        <v-toolbar flat color="primary" dark height="40" >
            <v-toolbar-title>
                <span>Quote Items</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn small color="blue" @click.prevent="addNewItem">Add New Item</v-btn>
        </v-toolbar>
        <v-layout row wrap>
            <v-flex xs12 sm6 md4 v-for="item in quoteData.items" :key="item.id">
                <v-card>
                    <v-img
                    :src="item.ImgUrlW400"
                    aspect-ratio="2.00"
                    >
                        <v-layout column fill-height class=" ">
                            <v-spacer></v-spacer>
                            <v-flex shrink pb-2>
                                <div class="headline primary lighten-5 text-xs-center">{{ item.itemNumber }}</div>
                                <!-- to custom item, allow upload image -->
                                <!-- <div class="text-xs-center" v-if="!item.itemId">
                                    <v-btn small color="info" @click="uploadItemImage(item)" >Upload Image</v-btn>
                                </div> -->
                            </v-flex>
                        </v-layout>
                    </v-img>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-layout row>
                            <v-flex xs-12 text-xs-center subheading>{{ item.description }}</v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs4 body-2 pt-1>Qty:</v-flex>
                            <v-flex xs8 text-xs-left pt-1>{{ item.qty }}</v-flex>
                        </v-layout>
                        <div v-show="userHasSalesSupportRole">
                            <v-layout row>
                                <v-flex xs4 body-2 pt-1>Unit:</v-flex>
                                <v-flex xs8 text-xs-left pt-1>{{ item.unit }}</v-flex>
                            </v-layout>
                            <v-layout row>
                                <v-flex xs4 body-2 pt-1>Unit Price:</v-flex>
                                <!-- <v-flex xs8 text-xs-left pt-1>{{ item.unitPrice  | toCurrency }}</v-flex> -->
                                <v-flex xs8 text-xs-left pt-1>{{ formatCurrency((!item.unitPrice? 0 : item.unitPrice), item.currnIdx) }}</v-flex>
                            </v-layout>
                            <v-layout row>
                                <v-flex xs4 body-2 pt-1>Price Level:</v-flex>
                                <v-flex xs8 text-xs-left pt-1>{{ item.unitPricePriceLevel }}</v-flex>
                            </v-layout>
                            <!-- <v-layout row>
                                <v-flex xs4 body-2 pt-1>Discount Per Unit:</v-flex>
                                <v-flex xs8 text-xs-left pt-1>{{ item.discountUnitAmt }}</v-flex>
                            </v-layout> -->
                            <v-layout row>
                                <v-flex xs4 body-2 pt-1>Discount:</v-flex>
                                <v-flex xs8 text-xs-left pt-1>{{ item.discountPct? `${item.discountPct}%` : "" }}</v-flex>
                            </v-layout>
                            <v-layout row>
                                <v-flex xs4 body-2 pt-1>Total Price:</v-flex>
                                <!-- <v-flex xs8 text-xs-left pt-1>{{ item.totalPrice | toCurrency }}</v-flex> -->
                                <v-flex xs8 text-xs-left pt-1>{{ formatCurrency((!item.totalPrice? 0 : item.totalPrice), item.currnIdx) }}</v-flex>
                            </v-layout>

                        </div>
                        <v-layout row>
                            <v-flex xs4 body-2 pt-1>Internal Notes:</v-flex>
                            <v-flex xs8 text-xs-left pt-1>
                                <div>{{ item.notes }}</div>
                                <div v-if="item.systemNotes && !(item.unitPrice > 0)" class="caption error--text">
                                    {{ item.systemNotes }}
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions v-show="canEditItem">
                        <v-spacer></v-spacer>
                        <v-btn small color="primary" @click.prevent="editItem(item)" >Edit</v-btn>
                        <v-btn small color="primary" @click.prevent="deleteItem(item)" >Delete</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="showItemEditPopup" width="500" height="400">
            <ctlQuoteItemEdit @onSaveItem="onSaveItem" :originalItemData="itemEditing"></ctlQuoteItemEdit>
        </v-dialog>

    </div>
</template>
<script>
import ctlQuoteItemEdit from '@/components/public/ctlQuoteItemEdit'
import { mapActions, mapGetters } from "vuex";

export default {
    props: ['quoteData'],
    components: {
        ctlQuoteItemEdit
    },
    data() {
        return {
            showItemEditPopup: false,
            itemEditing: null,
        }
    },
    computed: {
        ...mapGetters('auth', [
            'userHasSalesSupportRole'
        ]),
        quoteItemsActiveOnly () {
            return this.quoteData.items.filter(p=>p.active)
        },
        canEditItem () {
            return this.quoteData.basicInfo.statusId == "Editing" 
                || this.quoteData.basicInfo.statusId == "NeedMoreInfo" 
        }
    },
    methods: {
        ...mapActions('pubQuoteEdit', [
            'saveQuoteItem',
        ]),
        addNewItem() {
            // to new item, populate init data here
            this.itemEditing = {
                id : null,
                itemId : null,
                itemNumber : null,
                description : null,
                qty : null,
                discountPct : null,
                discountUnitAmt : null,
                unit : 'EACH',
                active : true,
                notes : null,
                quoteId : this.quoteData.id,
            }
            this.showItemEditPopup = true
        },
        editItem(item) {
            this.itemEditing = item
            this.showItemEditPopup = true
        },
        deleteItem(item) {
            if(item.id) {
                // existed item in db, set to inactive
                item.active = false
            } else {
                this.quoteData.items = this.quoteData.items.filter(p=> p != item)
            }
        },
        async deleteItem(item) {
            if(!confirm('Are you sure to delete this item?')) {
                return
            }
            if(item.id) {
                // existed item in db, set to inactive
                item.active = false
                await this.saveQuoteItem(item)

                //reload
                this.$emit('onSaveItem')
            } else {
                this.quoteData.items = this.quoteData.items.filter(p=> p != item)
            }
        },
        onSaveItem(newOrExistedItem) {
            this.showItemEditPopup = false

            // if (newOrExistedItem) {
            //     // if(newOrExistedItem.id) {
            //     //     var existedItem = this.quoteData.items.find(o=>o.id === newOrExistedItem.id)
            //     //     existedItem = Object.assign({}, existedItem, newOrExistedItem)
            //     // }else {
            //     //     }
            //     var foundItem = this.quoteData.items.find(o=>o.itemNumber === newOrExistedItem.itemNumber)
            //     if (!foundItem) {
            //         this.quoteData.items = [...this.quoteData.items, newOrExistedItem]
            //     } else {
            //         foundItem = Object.assign({}, foundItem, newOrExistedItem)
            //     }
            // }
            //bubble up to upper
            this.$emit('onSaveItem')
        }
    }
}
</script>
